import {BaseEntity} from "../base-entity";

export const ConfigurationPropertNameValues = {
    licenseParsingEnabled: 'LicenseParsingEnabled'
};

export class SystemConfiguration extends BaseEntity {
    configurationType: string;
    configurationOptionValues : ConfigurationOptionValue[] = [];

    constructor(systemConfiguration?: SystemConfiguration){
        super();
        if(systemConfiguration){
            if(systemConfiguration.configurationOptionValues){
                systemConfiguration.configurationOptionValues.forEach((value)=>{
                    this.configurationOptionValues.push(new ConfigurationOptionValue(value));
                })
            }
        }
    }

    getConfigurationValueByProperty(propertyName: string): ConfigurationOptionValue {
        if(this.configurationOptionValues.length > 0) {
            for(let configurationOptionValue of this.configurationOptionValues) {
                if(configurationOptionValue.configurationOption.fieldName == propertyName) {
                    return configurationOptionValue;
                }
            }
        }
        return null;
    }
}

export class ConfigurationOptionValue {

    configurationValue: string;
    configurationId: string;
    configurationOption: ConfigurationOption;

    constructor(configurationOptionValue: ConfigurationOptionValue) {
        this.configurationValue = configurationOptionValue.configurationValue;
        this.configurationId = configurationOptionValue.configurationId;
        this.configurationOption = new ConfigurationOption(configurationOptionValue.configurationOption);
    }

}

export class ConfigurationOption {
    id: number;
    fieldName: string;
    description: string;
    optionOrder: number;

    constructor(configurationOption: ConfigurationOption) {
        this.id = configurationOption.id;
        this.fieldName = configurationOption.fieldName;
        this.description = configurationOption.description;
        this.optionOrder = configurationOption.optionOrder;
    }

}